module.exports = __webpack_public_path__ + "static/img/guess.85d51fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/online/guess.svg
// module id = THVc
// module chunks = 83